// extracted by mini-css-extract-plugin
export var active = "_tm-1";
export var circle = "_tm-0";
export var completed = "_tm-2";
export var connector = "_tm-4";
export var connectorCompleted = "_tm-7";
export var connectorSpacer = "_tm-5";
export var iconStrokeOverride = "_tm-8";
export var labelContainer = "_tm-6";
export var pending = "_tm-3";